var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownLong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.15,
    transform: "rotate(-180 12.5 12.5)",
    fill: "url(#paint0_linear_6434_1582)",
    stroke: "url(#paint1_linear_6434_1582)",
    strokeWidth: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 6C13.75 5.58579 13.4142 5.25 13 5.25C12.5858 5.25 12.25 5.58579 12.25 6H13.75ZM12.4697 19.5303C12.7626 19.8232 13.2374 19.8232 13.5303 19.5303L18.3033 14.7574C18.5962 14.4645 18.5962 13.9896 18.3033 13.6967C18.0104 13.4038 17.5355 13.4038 17.2426 13.6967L13 17.9393L8.75736 13.6967C8.46447 13.4038 7.98959 13.4038 7.6967 13.6967C7.40381 13.9896 7.40381 14.4645 7.6967 14.7574L12.4697 19.5303ZM13 6H12.25L12.25 19H13H13.75L13.75 6H13Z",
    fill: "#F3F2F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6434_1582",
    x1: 12.5,
    y1: 0,
    x2: 12.5,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0C0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6434_1582",
    x1: 12.5,
    y1: 0,
    x2: 12.5,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0C0C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownLong);
export default __webpack_public_path__ + "static/media/arrow-down-long.de8ba046da4f6e2841197c20ec95f3ba.svg";
export { ForwardRef as ReactComponent };